import { debounce } from 'lodash'
import { DashboardHeader } from '@modules/admin/Admin.Header'
import FilterBar from '@modules/admin/shared/FiltersBar'
import AccessControl from '@modules/auth/AccessControl'
import CustomPagination from '@modules/tableComponents/Pagination'
import SelectCompanyField from '@modules/formFields/SelectCompanyField'
import SelectSpecialityField from '@modules/formFields/SelectSpecialityField'
import React, { Component } from 'react'
import { Trans, withTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import Consultations from '@services/Consultations'
import Loading from '../../core/components/Loading'
import { SentenceTable } from './Sentence.Index.Table'

class SentenceIndex extends Component {
  clientSentence = Consultations.sentence

  state = {
    search: '',
    sentences: [],
    page: null,
    pageSize: 50,
    total: 0,
    isFetching: false,
    companyFilter: undefined,
    specialityFilter: [],
  }

  onTypeSearch = (search) => {
    return this.setState({ search, page: 1 }, this.debouncedFetch)
  }
  handleChangePage = (page) => {
    return this.setState({ page }, () => this.fetchSentences())
  }
  fetchSentences = () => {
    const { page, pageSize } = this.state
    this.setState({ isFetching: true })

    const filters = {
      search: this.state.search,
      company_api_keys: this.state.companyFilter ? this.state.companyFilter.map((co) => co.api_key) : undefined,
      speciality_ids: this.state.specialityFilter
        ? this.state.specialityFilter.map((speciality) => speciality.id)
        : undefined,
    }

    return this.clientSentence
      .index({ page, pageSize, ...filters })
      .then((response) => {
        this.setState({
          sentences: response.data,
          page: response.meta.current_page,
          lastPage: response.meta.last_page,
          total: response.meta.total,
          isFetching: false,
        })
      })
      .catch((err) => {
        console.error(err)
        this.setState({ isFetching: false, sentences: [] })
      })
  }
  debouncedFetch = debounce(this.fetchSentences, 350, false)

  componentDidMount() {
    this.fetchSentences()
  }

  render() {
    const { search, sentences, isFetching, total } = this.state
    const { t } = this.props
    return (
      <div>
        <DashboardHeader title={<Trans>Frases Hechas</Trans>} total={total}>
          <AccessControl requiredRole="company">
            <Link to={`sentence/create`} className="btn btn-primary">
              <Trans>Crear</Trans>
            </Link>
          </AccessControl>
        </DashboardHeader>

        <FilterBar value={search} onChange={this.onTypeSearch}>
          <AccessControl>
            <SelectCompanyField
              placeholder={t('Compañías')}
              multi
              input={{
                value: this.state.companyFilter,
                onChange: (companies) => this.setState({ companyFilter: companies, page: 1 }),
              }}
            />
          </AccessControl>
          <SelectSpecialityField
            placeholder={t('Especialidades')}
            multi
            input={{
              value: this.state.specialityFilter,
              onChange: (specialities) => this.setState({ specialityFilter: specialities, page: 1 }),
            }}
          />
        </FilterBar>

        <Loading isFetching={isFetching} />

        <SentenceTable sentences={sentences} />

        <CustomPagination
          onClickItem={this.handleChangePage}
          activePage={this.state.page}
          totalPages={this.state.lastPage}
          maxButtons={7}
        />
      </div>
    )
  }
}

export default withTranslation()(SentenceIndex)
